<template>
  <el-dialog
    class="freeBookingBox"
    :visible.sync="dialogVisible"
    width="1080px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
  >
    <div class="fl dialog-left">
      <p class="dialog-title">请填写在线预订信息</p>
      <el-form :inline="true" :validate-event="true" :model="bookingData" class="demo-form-inline">
        <el-form-item>
          <el-input clearable v-model="bookingData.userName" placeholder="姓名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input type="number" clearable v-model="bookingData.userTel" placeholder="手机号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input @input="inputArea" clearable v-model="bookingData.area" placeholder="房屋面积/m²"></el-input>
        </el-form-item>
        <v-distpicker :placeholders="placeholders" @selected="onSelected"></v-distpicker>

        <el-form-item>
          <el-input clearable v-model="bookingData.addr" placeholder="小区详细地址"></el-input>
        </el-form-item>

        <el-form-item>
          <el-select clearable filterable v-model="bookingData.projectId" placeholder="请选择服务项目">
            <el-option
              v-for="item in serveProjects"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <p class="booking-btn" @click="appointmentSubmit">立即预约</p>
    </div>
    <div class="fr dialog-right">
      <p class="dialog-title">已预约人数</p>
      <!-- :data 绑定数据 才能滑动 -->
      <vue-seamless-scroll
        :data="appointmentList"
        class="seamless-warp"
        :class-option="optionSetting"
      >
        <ul class="booking-list">
          <li v-for="item in appointmentList" :key="item.number">
            <p>{{item.number}}</p>
            <p>{{item.userName}}</p>
            <p v-if="item.addr">{{item.addr.substring(0,7)}}</p>
            <p v-else>暂无</p>
            <p>{{item.projectName.substring(0,4)}}</p>
            <p>{{item.userTel}}</p>
            <p class="color-theme">{{item.identification}}</p>
          </li>
        </ul>
      </vue-seamless-scroll>
    </div>
  </el-dialog>
</template>

<script>
import * as indexApi from "@/api/indexApi";
import VDistpicker from "v-distpicker";
export default {
  components: {
    VDistpicker
  },
  data() {
    return {
      imgUrl: process.env.IMG_URL, //全局
      dialogVisible: true,
      bookingData: {
        userName: "",
        userTel: "",
        projectId: "",
        area: "", //面积
        province: "", //地址
        city: "",
        county: "",
        addr: ""
      },
      serveProjects: [],
      placeholders: {
        province: "省",
        city: "市",
        area: "区"
      },
      appointmentList: []
    };
  },
  computed: {
    optionSetting() {
      return {
        step: 0.4
      };
    }
  },
  methods: {
    // 面积是整数类型
    inputArea(e) {
      this.bookingData.area = e.replace(/[^0-9]/g, "");
    },
    getServeProject() {
      // 获取服务列表
      indexApi.getServeProject().then(res => {
        if (res.data.code == "200") {
          this.serveProjects = res.data.data;
        }
      });
    },
    // 地区选择
    onSelected(data) {
      this.bookingData.province = data.province.value;
      this.bookingData.city = data.city.value;
      this.bookingData.county = data.area.value;
    },
    // 立即预约
    appointmentSubmit() {
      if (
        this.paramsValidate(this.bookingData) &&
        this.bookingData.province != "省" &&
        this.bookingData.city != "市" &&
        this.bookingData.county != "区"
      ) {
        // 发起请求
        indexApi.appointmentSubmit(this.bookingData).then(res => {
          if (res.data.code == "200") {
            this.$message.success(res.data.data);
          }
        });
      } else {
        this.$message.warning("请填写完整!");
      }
    },

    handleClose(done) {
      this.bookingData = {
        userName: "",
        userTel: "",
        projectId: "",
        area: "", //面积
        province: "", //地址
        city: "",
        county: "",
        addr: ""
      };
      done();
      this.$parent.dialogVisible = false;
    },
    // 预约列表
    findUserAppointmentList() {
      indexApi.findUserAppointmentList().then(res => {
        if (res.data.code == "200") {
          this.appointmentList = res.data.data;
        }
      });
    }
  },
  created: function() {
    this.getServeProject();
    this.findUserAppointmentList();
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
.freeBookingBox {
  // 免费预约弹框
  .el-dialog {
    .dialog-title {
      font-size: 26px;
      color: rgba(162, 10, 14, 1);
      text-align: center;
      margin-bottom: 35px;
    }
    .dialog-left {
      width: 166px;
    }
    .dialog-left {
      width: 419px;
      margin-left: 70px;
      margin-top: 34px;

      .booking-btn {
        height: 42px;
        line-height: 42px;
        text-align: center;
        background: #a20a0e;
        color: #fff;
        font-size: 16px;
        font-weight: bold;
      }
      .booking-btn:hover {
        cursor: pointer;
      }
    }
    .dialog-right {
      width: 510px;
      height: 430px;
      margin-left: 40px;
      margin-top: 110px;
      border-left: 1px dashed #dcdcdc;
      padding-left: 20px;
      box-sizing: border-box;
      .seamless-warp {
        height: 364px;
        overflow: hidden;
      }
      // .booking-list{
      li {
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        color: #3e3e3e;
        p {
          float: left;
          margin-right: 10px;
          display: -webkit-box;
          /*! autoprefixer: off */
          -webkit-box-orient: vertical;
          /*autoprefixer: on */
          -webkit-line-clamp: 1;
          word-wrap: break-word;
          word-break: break-all;
          overflow: hidden;
        }
        p:nth-child(1) {
          width: 40px !important;
        }
        p:nth-child(2) {
          width: 60px !important;
        }
        p:nth-child(3) {
          width: 110px !important;
        }
        p:nth-child(4) {
          width: 60px !important;
        }
        p:nth-child(5) {
          width: 92px !important;
        }
      }
      // }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/freeBookingBox.vue